// Slow, continuous editorial marquee used as a section divider.
export function Marquee({ words = ["Strategic", "Discreet", "Powerful", "Chicago-Rooted"], className = "" }) {
  const sequence = [...words, ...words, ...words, ...words];
  return (
    <div
      className={`relative overflow-hidden border-y border-navy/10 bg-cream py-6 md:py-8 ${className}`}
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {sequence.map((w, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 md:mx-10 md:gap-10">
            <span className="font-serif text-4xl font-500 text-outline-navy md:text-6xl">{w}</span>
            <span className="h-2 w-2 rotate-45 bg-gold/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
